import React, { useState, Fragment, useEffect } from "react";
import {
  Row,
  Button,
  Collapse,
  Input,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Table,
} from "reactstrap";
import { MainCard, Field } from "bx-react-ui";
import { CircularProgress } from "../UI/CircularProgress/CircularProgress";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { useSelector } from "react-redux";
import moment from "moment";

import { getArchivesTypes } from "../../services/api/accounts";
import { uploadFiles, getFile } from "../../services/api/person";
import { showToast } from "../../utils/global";
import arrow from "../../../public/svg/keyboard_arrow_down.svg";
import downloadSvg from "../../../public/svg/download-svgrepo-com.svg";
import { toPascalCase } from "../../utils/helper";

import { getSavedPersonInfo } from "../../reducers/selectors";
import { DocumentTable } from "../DocumentTable/DocumentTable";

import style from "./ProfileInfoForm.scss";
import { DayCountFractions } from "bx-react-ui/src/components/Asset/types";

export const ProfileInfoForm = () => {
  const [fields, setFields] = useState({});
  const [loading, setLoading] = useState(false);
  const [loadingInfo, setLoadingInfo] = useState(true);
  const [open, setOpen] = useState(false);
  const todayDate = new Date().toISOString().slice(0, 10);
  const [expirationDate, setExpirationDate] = useState(todayDate);
  const [docType, setDocType] = useState({ id: 0, name: "Tipo de documento" });
  const [date, setDate] = useState();
  const [pdf, setPdf] = useState();
  const [addDoc, setAddDoc] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [contracts, setContracts] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [errors, setErrors] = useState({});

  const [fileToUpload, setFileToUpload] = useState({ blob: "" });

  const personInfo = useSelector(getSavedPersonInfo);

  useEffect(() => {
    if (personInfo) {
      const newContracts = [];
      const newDocuments = [];

      personInfo.Archives.map((archiveItem) => {
        if (archiveItem.PersonArchiveSubTypeInternalName === "Contract") newContracts.push(archiveItem);
        else newDocuments.push(archiveItem);
      });

      setContracts(newContracts);
      setDocuments(newDocuments);
    }
  }, [personInfo]);

  useEffect(() => {
    getArchivesTypes().then(({ response }) => {
      setDocumentTypes(response.archivesTypes);
    });
  }, []);

  const handleFileInput = (event) => {
    const blob = event.target.files[0];

    if (blob && blob.size <= 5242880) {
      const name = blob.name.substring(0, blob.name.indexOf("."));
      const extension = blob.name.substring(blob.name.indexOf(".") + 1, blob.name.length);
      setFileToUpload((prevFile) => {
        return { ...prevFile, blob, name, extension };
      });
      setErrors((prevErrors) => {
        delete prevErrors["blob"];
        return prevErrors;
      });
    } else {
      alert("El archivo es demasiado grande! (Max. 5MB)");
      event.target = null;
    }
  };

  const validateFields = () => {
    const newErrors = {};

    if (fileToUpload.blob === "") {
      newErrors["blob"] = "Campo requerido";
    }
    if (!fileToUpload.lifelong && fileToUpload.expirationDate === "") {
      newErrors["expirationDate"] = "Campo requerido";
    }

    return newErrors;
  };

  const validateAndSend = () => {
    const newErrors = validateFields();
    if (Object.keys(newErrors).length !== 0) {
      setErrors({ ...newErrors });
    } else {
      setLoading(true);
      if (fileToUpload.typeId != 0) {
        var reader = new FileReader();
        reader.readAsDataURL(fileToUpload.blob);
        reader.onload = () => {
          const postArchive = {
            ...fileToUpload,
            hasExpiration: true,
            expirationDate,
            blob: reader.result,
            typeId: docType.id,
          };

          uploadFiles(postArchive)
            .then(({ response }) => {
              if (response.result.Code !== 200)
                showToast("Se produjo un error al intentar guardar el documento", true);
              else {
                setUploaded(true);
                showToast("Documento enviado para revisión exitosamente");
              }
            })
            .catch((err) => console.error(err))
            .finally(() => {
              setLoading(false);
            });
        };
      }
    }
  };

  const reloadForm = () => {
    window.location.reload();
  };

  const toggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const addDocument = () => {};

  const changeDateHandler = (event) => {
    event.target.id === "expirationDate" ? setExpirationDate(event.target.value) : null;
  };

  const handleDownload = (file) => {
    const body = {
      fileId: file.PersonArchiveId,
    };
    getFile(body)
      .then(({ response }) => {
        var a = document.createElement("A");
        a.href = `data:application/octet-stream;base64,${response.blobfile}`;
        a.download = `${file.PersonArchivesName}.${file.PersonArchivesExtension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => console.error(err));
  };

  if (uploaded) {
    return (
      <Fragment>
        <Row className={style.row}>
          <Button className={style.addButton} onClick={reloadForm}>
            Volver
          </Button>
        </Row>
      </Fragment>
    );
  }

  if (!personInfo) return <CircularProgress />;

  return (
    <Fragment>
      <Row className={style.row}>
        <LaddaButton
          className={style.addButton}
          loading={loading}
          disabled={loading}
          onClick={validateAndSend}
          data-style={EXPAND_RIGHT}
        >
          {loading ? "Cargando..." : "Agregar nuevo documento"}
        </LaddaButton>
      </Row>
      <Row className={style.row}>
        <span className={style.dropdownContainer}>
          <Dropdown
            isOpen={open}
            className={style.dropdown}
            toggle={toggle}
            onChange={(undefined, v) => setOpen(v)}
          >
            <DropdownToggle nav caret className={style.dropdownToggle}>
              {docType.name}
              <img src={arrow} className={open ? style.arrowActive : style.arrow} alt="arrow" />
              <DropdownMenu id={style.dropdownMenu}>
                {documentTypes.map((documentTypeItem) => (
                  <DropdownItem
                    className={style.item}
                    onClick={() => {
                      setOpen(false);
                      setDocType(documentTypeItem);
                    }}
                  >
                    {documentTypeItem.name}
                  </DropdownItem>
                ))}
              </DropdownMenu>
            </DropdownToggle>
          </Dropdown>

          {/* <Button className={style.selectFileButton}>Seleccionar archivo</Button> */}
          <Field error={errors.blob} style={{ marginBottom: 0, display: "flex", alignItems: "center" }}>
            <div className={style.selectFileButton}>
              <Input
                type="file"
                label={"Seleccionar archivo"}
                dataMaxSize="2048"
                accept="application/pdf"
                onChange={handleFileInput}
                name="blob"
                id="blob"
                disabled={uploaded}
                className={style.selectFileInput}
              />
            </div>
          </Field>
        </span>
      </Row>
      <Row className={style.row}>
        <span className={style.expirtionDateContainer}>
          <div className={style.expirationDate}>Fecha de vencimiento</div>
          <Input
            type="date"
            className={style.input}
            name="expirationDate"
            id="expirationDate"
            value={expirationDate}
            onChange={changeDateHandler}
          />
        </span>
      </Row>

      <Row className={`${style.row} ${style.documentRowWrapper}`}>
        <div className={style.subTitle}>Contrato</div>
        {contracts.length === 0 && <span>No hay contratos</span>}
        {contracts.map((documentItem) => {
          return (
            <ContractRow documentItem={documentItem} handleDownload={() => handleDownload(documentItem)} />
          );
        })}
      </Row>

      <Row className={`${style.row} ${style.documentRowWrapper}`}>
        <div className={style.subTitle}>Documentos subidos</div>
        {documents.length === 0 && <span>No hay documentos</span>}
        {documents.map((documentItem) => {
          return (
            <DocumentRow documentItem={documentItem} handleDownload={() => handleDownload(documentItem)} />
          );
        })}
      </Row>
    </Fragment>
  );
};

const ContractRow = ({ documentItem, handleDownload }) => {
  const dateString = `Fecha de autorización: ${
    documentItem.PersonArchivesHasExpirationDate
      ? moment(documentItem.PersonArchivesExpirationDate).format("DD/MM/YYYY")
      : "-"
  }`;

  return (
    <div className={style.documentRow}>
      <span className={style.documentRowItem}>{documentItem.PersonArchivesSubTypeDescription}</span>
      <span className={style.documentRowItem}>{dateString}</span>
      <span onClick={handleDownload}>
        <img src={downloadSvg} className={style.icon} alt="download" />
      </span>
    </div>
  );
};

const DocumentRow = ({ documentItem, handleDownload }) => {
  const dateString = documentItem.PersonArchivesHasExpirationDate
    ? `Fecha de vencimiento: ${moment(documentItem.PersonArchivesExpirationDate).format("DD/MM/YYYY")}`
    : "No expira";

  return (
    <div className={style.documentRow}>
      <span className={style.documentRowItem}>{documentItem.PersonArchivesSubTypeDescription}</span>
      <span className={style.documentRowItem}>{dateString}</span>
      <span onClick={handleDownload}>
        <img src={downloadSvg} className={style.icon} alt="download" />
      </span>
    </div>
  );
};
